import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, mergeProps as _mergeProps, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7f7d72e6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "uf-auth-detail",
  style: {"padding":"0","border-bottom":"0"}
}
const _hoisted_2 = {
  class: "uf-auth-detail__group",
  style: {"padding-top":"0"}
}
const _hoisted_3 = {
  key: 0,
  class: "uf-auth-detail__idcard-images"
}
const _hoisted_4 = {
  class: "uf-auth-detail__item",
  style: {"margin-top":"10px"}
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  class: "uf-auth-detail__item",
  style: {"margin-top":"10px"}
}
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "uf-uploader__preview-image" }
const _hoisted_9 = { class: "uf-uploader__preview-content" }
const _hoisted_10 = { class: "uf-uploader__preview-content-title" }
const _hoisted_11 = { class: "uf-uploader__preview-content-size" }
const _hoisted_12 = {
  class: "uf-auth-detail__item",
  style: {"margin-top":"10px"}
}
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "uf-uploader__preview-image" }
const _hoisted_15 = { class: "uf-uploader__preview-content" }
const _hoisted_16 = { class: "uf-uploader__preview-content-title" }
const _hoisted_17 = { class: "uf-uploader__preview-content-size" }
const _hoisted_18 = { class: "uf-auth-detail__item-title" }
const _hoisted_19 = { class: "uf-auth-detail__item-title" }
const _hoisted_20 = { class: "uf-auth-detail__item-title" }
const _hoisted_21 = { class: "uf-auth-detail__item-title" }
const _hoisted_22 = { class: "uf-company__body" }
const _hoisted_23 = { class: "uf-company__info" }
const _hoisted_24 = { class: "uf-button" }
const _hoisted_25 = { class: "uf-button--footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_image = _resolveComponent("van-image")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_field = _resolveComponent("van-field")!
  const _component_uf_form_item = _resolveComponent("uf-form-item")!
  const _component_van_nav_bar = _resolveComponent("van-nav-bar")!
  const _component_sub_form_item_group = _resolveComponent("sub-form-item-group")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_popup = _resolveComponent("van-popup")!
  const _component_van_action_sheet = _resolveComponent("van-action-sheet")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_uf_form_item, {
      title: _ctx.options.title,
      required: _ctx.options.is_checked == '1',
      readonly: _ctx.disabled
    }, {
      default: _withCtx(() => [
        (_ctx.$route.name != _ctx.$RouterName.APPROVAL_START && _ctx.disabled)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list.flat(), (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "uf-auth-detail__item",
                    key: index
                  }, [
                    (item.type == 'check_id_photo' && item.pic_arr?.length != 0)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          (item.pic_arr)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.pic_arr, (photo) => {
                                  return (_openBlock(), _createBlock(_component_van_image, {
                                    key: photo.id,
                                    class: "uf-auth-detail__idcard-image",
                                    height: "105px",
                                    fit: "contain",
                                    src: photo.photo_thumb_file,
                                    onClick: ($event: any) => (_ctx.ImagePreview([photo.photo_file]))
                                  }, null, 8, ["src", "onClick"]))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true)
                        ], 64))
                      : (item.type == 'check_pic' && item.pic_arr?.length != 0)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createElementVNode("div", _hoisted_4, _toDisplayString(item.title) + ":", 1),
                            (item.pic_arr)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.pic_arr, (photo) => {
                                    return (_openBlock(), _createBlock(_component_van_image, {
                                      key: photo.id,
                                      height: "105px",
                                      fit: "contain",
                                      src: photo.photo_thumb_file,
                                      onClick: ($event: any) => (_ctx.ImagePreview([photo.photo_file]))
                                    }, null, 8, ["src", "onClick"]))
                                  }), 128))
                                ]))
                              : _createCommentVNode("", true)
                          ], 64))
                        : (item.type == 'check_file' && item.pic_arr?.length != 0)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                              _createElementVNode("div", _hoisted_6, _toDisplayString(item.title) + ":", 1),
                              (item.pic_arr)
                                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(item.pic_arr, (item) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      class: "uf-uploader__preview",
                                      key: item.id,
                                      onClick: ($event: any) => (_ctx.download(item))
                                    }, [
                                      _createElementVNode("div", _hoisted_8, [
                                        _createVNode(_component_van_icon, { name: "column" })
                                      ]),
                                      _createElementVNode("div", _hoisted_9, [
                                        _createElementVNode("div", _hoisted_10, _toDisplayString(item.file_name), 1),
                                        _createElementVNode("div", _hoisted_11, _toDisplayString(item.file_size) + "KB", 1)
                                      ])
                                    ], 8, _hoisted_7))
                                  }), 128))
                                : _createCommentVNode("", true)
                            ], 64))
                          : (item.type == 'check_nvq' && item.nvq_arr?.length != 0)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                _createElementVNode("div", _hoisted_12, _toDisplayString(item.title) + ":", 1),
                                (item.nvq_arr)
                                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(item.nvq_arr, (certificate) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        class: "uf-uploader__preview",
                                        key: certificate.id,
                                        onClick: ($event: any) => (_ctx.download(certificate))
                                      }, [
                                        _createElementVNode("div", _hoisted_14, [
                                          _createVNode(_component_van_icon, { name: "column" })
                                        ]),
                                        _createElementVNode("div", _hoisted_15, [
                                          _createElementVNode("div", _hoisted_16, _toDisplayString(certificate.file_name), 1),
                                          _createElementVNode("div", _hoisted_17, _toDisplayString(certificate.file_size) + "KB", 1)
                                        ])
                                      ], 8, _hoisted_13))
                                    }), 128))
                                  : _createCommentVNode("", true)
                              ], 64))
                            : (item.type == 'check_region')
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                                  _createElementVNode("i", _hoisted_18, _toDisplayString(item.title) + " :", 1),
                                  _createTextVNode(" " + _toDisplayString(item.region || "无"), 1)
                                ], 64))
                              : (item.type == 'check_dateslot')
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                                    _createElementVNode("i", _hoisted_19, _toDisplayString(item.title) + " :", 1),
                                    _createTextVNode(" " + _toDisplayString(_ctx.showDate(item.result) || "无"), 1)
                                  ], 64))
                                : (item.type == 'check_radio')
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                                      _createElementVNode("i", _hoisted_20, _toDisplayString(item.title) + " :", 1),
                                      _createTextVNode(" " + _toDisplayString(item.option.find(i => String(i.key) == item.result)?.value), 1)
                                    ], 64))
                                  : (_openBlock(), _createElementBlock(_Fragment, { key: 7 }, [
                                      _createElementVNode("i", _hoisted_21, _toDisplayString(item.title) + " :", 1),
                                      _createTextVNode(" " + _toDisplayString(item.result || "无"), 1)
                                    ], 64))
                  ]))
                }), 128))
              ])
            ]))
          : (_openBlock(), _createBlock(_component_van_field, _mergeProps({
              key: 1,
              placeholder: "请填写",
              modelValue: _ctx.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.value) = $event)),
              readonly: ""
            }, _ctx.$attrs, {
              "is-link": !_ctx.disabled,
              onClick: _ctx.onClick
            }), null, 16, ["modelValue", "is-link", "onClick"]))
      ]),
      _: 1
    }, 8, ["title", "required", "readonly"]),
    _createVNode(_component_van_popup, {
      "close-on-popstate": true,
      show: _ctx.popupShow,
      "onUpdate:show": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.popupShow) = $event)),
      position: "right",
      style: { height: '100%', width: '100%' },
      "lazy-render": false
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_22, [
          _createVNode(_component_van_nav_bar, {
            title: '填写' + _ctx.options.title,
            "left-text": "返回",
            "left-arrow": "",
            onClickLeft: _cache[1] || (_cache[1] = ($event: any) => (_ctx.popupShow = false))
          }, null, 8, ["title"]),
          _createElementVNode("div", _hoisted_23, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item, index) => {
              return (_openBlock(), _createBlock(_component_sub_form_item_group, {
                key: index,
                list: item,
                id: _ctx.id,
                ref_for: true,
                ref: 
              el => {
                if (el) _ctx.itemRefs[index] = el;
              }
            
              }, null, 8, ["list", "id"]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, [
              _createVNode(_component_van_button, {
                class: "btn",
                block: "",
                color: "#3d6eeb",
                square: "",
                type: "success",
                onClick: _ctx.confirm
              }, {
                default: _withCtx(() => [
                  _createTextVNode("确认 ")
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_van_action_sheet, {
      show: _ctx.show,
      "onUpdate:show": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.show) = $event)),
      actions: _ctx.actions,
      "cancel-text": "取消",
      "close-on-click-action": "",
      onSelect: _ctx.onSelect
    }, null, 8, ["show", "actions", "onSelect"])
  ], 64))
}